export const environment = {
    production: true,
    showLogs: false,
    baseURL: 'https://api.atom.abac.software/api',
    notificationQueue: 'notificationsPublisher',
    enableAutoSessionTermination: true,
    badgeInactivityTimeoutSeconds: 30,
    badgeLogoutCountdownSeconds: 10,
    msalEnable: false,
    msalModuleConfig: {
        clientId: '10516298-2384-4a63-99e5-52f675fe0bc9',
        authority: 'https://login.microsoftonline.com/0ae51e19-07c8-4e4b-bb6d-648ee58410f4',
        redirectUri: 'http://localhost:4200',
        microsoftGraph: 'https://graph.microsoft.com/v1.0/me',
        scopes: 'api://10516298-2384-4a63-99e5-52f675fe0bc9/access_as_user'
    },
    toasts: {
        duration: 20000
    },
    mocks: {
        forgotPassword: false,
        offlineMode: false,
        lifts: false,
        strain: false,
        sampleBoards: false,
        dashboard: false
    }
};
